import { useState, type ReactNode } from "react";
import "./KanbanStack.css";

export interface KanbanStackProps {
  label: string;
  count: number;
  totalValue?: string;
  children: ReactNode;
  defaultOpen?: boolean;
}

/** A collapsed "deck" of cards for one group inside a board column, expanding in place to the full card list. */
export function KanbanStack({ label, count, totalValue, children, defaultOpen = false }: KanbanStackProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return (
    <div className={`ui-kanban-stack${isOpen ? " is-open" : ""}`}>
      <button
        type="button"
        className="ui-kanban-stack__deck"
        aria-expanded={isOpen}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {!isOpen && count > 2 && <span className="ui-kanban-stack__peek ui-kanban-stack__peek--2" aria-hidden="true" />}
        {!isOpen && count > 1 && <span className="ui-kanban-stack__peek ui-kanban-stack__peek--1" aria-hidden="true" />}
        <span className="ui-kanban-stack__face">
          <span className="ui-kanban-stack__label">{label}</span>
          <span className="ui-kanban-stack__meta">
            {totalValue ? <span className="ui-kanban-stack__value">{totalValue}</span> : null}
            <span className="ui-kanban-stack__count">({count})</span>
            <span className="ui-kanban-stack__chevron" aria-hidden="true">▼</span>
          </span>
        </span>
      </button>
      {isOpen && <div className="ui-kanban-stack__body">{children}</div>}
    </div>
  );
}
